/**
 * Created by yangshasha on 2025/8/11.
 * Copyright © 2024年 云柜-金星晖. All rights reserved.
 * 功能：商户管理
 */
import BaseApi from '@/request/base/BaseApi';

class AgentApiSet {
  constructor () {
    // 新增
    this.thirdMerchantList = BaseApi.createModel('组织管理-商户管理-商户列表', '/opmp/admin/saMerchant/list').setMethod(1);
    this.thirdMerchantDetail = BaseApi.createModel('组织管理-商户管理-商户详情', '/opmp/admin/saMerchant/detail').setMethod(1);
    this.thirdMerchantUpdate = BaseApi.createModel('组织管理-商户管理-更新/编辑', '/opmp/admin/saMerchant/update').setMethod(1);
    this.thirdMerchantAdd = BaseApi.createModel('组织管理-商户管理-新增', '/opmp/admin/saMerchant/add').setMethod(1);
    this.smsCheck = BaseApi.createModel('组织管理-商户管理-短信核验', '/opmp/admin/saMerchant/smsCheck').setMethod(1);
    this.merchantCommunityRelationList = BaseApi.createModel('组织管理-商户管理-商户-关联小区-进入展示列表', '/opmp/admin/saMerchant/merchantCommunityRelationList').setMethod(1);
    this.merchantCommunityRelation = BaseApi.createModel('组织管理-商户管理-关联小区-关联按钮', '/opmp/admin/saMerchant/merchantCommunityRelation').setMethod(1);
    this.removeMerchantCommunityRelation = BaseApi.createModel('组织管理-商户管理-关联小区-解除关联', '/opmp/admin/saMerchant/removeMerchantCommunityRelation').setMethod(1);
    this.communityList = BaseApi.createModel('组织管理-商户管理-关联小区-选择关联小区列表', '/opmp/admin/saMerchant/communityList').setMethod(1);
  }
}

export default new AgentApiSet();
